module.exports = __webpack_public_path__ + "img/factory-reset.bb2309a1.svg";